import { render, staticRenderFns } from "./AdminCopilot.pug?vue&type=template&id=15337ce6&external"
import script from "./AdminCopilot.js?vue&type=script&lang=js&external"
export * from "./AdminCopilot.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports